import { render, h } from 'preact';

import loadJsonScript from '../utils/load-json-script';

import EmbedApp from '../EmbedApp';

const EMBED_TYPES = ['map', 'mapswitch', 'contest', 'balance', 'category'];

// Other names that work in the URL (?region= is the regional breakdown)
const TYPE_ALIASES: { [alias: string]: string } = { region: 'category' };

const params = new URLSearchParams(location.search);

// Keep the order the embeds were checked in the builder, across all types
const items = Array.from(params)
  .map(([type, slug]) => ({ type: TYPE_ALIASES[type] || type, slug }))
  .filter(({ type }) => EMBED_TYPES.indexOf(type) >= 0);

// Pages like the homepage embed can set what shows when the URL picks nothing
if (!items.length) items.push(...(loadJsonScript('default_embed_items') || []));

// ?button=1 swaps the "View results" text link for the gray button
const buttonLink = params.has('button');

const annotations = loadJsonScript('annotations_data');

const notes = loadJsonScript('notes_data');

render(
  <EmbedApp
    items={items}
    annotations={annotations}
    notes={notes}
    buttonLink={buttonLink}
    embedType={'internal'}
  />,
  document.getElementById('app')
);
